import { render, staticRenderFns } from "./AddressOverwrite.vue?vue&type=template&id=2c58ce0d&scoped=true"
import script from "./AddressOverwrite.vue?vue&type=script&lang=js"
export * from "./AddressOverwrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58ce0d",
  null
  
)

export default component.exports